/*Text Carousel on Product Page*/


jQuery( document ).ready(function() {   
    var current3g = 1;
    var max3g = jQuery( "li.slidercontent-3g" ).length +1;
    
    jQuery("slidercontent-3g").hide();
    jQuery("slidercontent-3g:nth-child(1)").fadeIn("slow");
    
    //function to change to next quote
    function changeUp() {
      jQuery(".slidercontent-3g").hide();
      current3g += 1;
      if (current3g === max3g || current3g > max3g) {
        current3g = 1;
      }
    
      jQuery(".slidercontent-3g:nth-child(" + current3g + ")").fadeIn("slow");
    }
    
    function changeDown() {
      jQuery(".slidercontent-3g").hide();
      current3g -= 1;
    
      if (current3g === 0) {
        current3g = max3g - 1;
      }
      
      jQuery(".slidercontent-3g:nth-child(" + current3g + ")").fadeIn("slow");
    }
    
    startChange();
    
    jQuery(".sliderspot.spot2").click(function() { 
      stopChange();
      changeUp();
      startChange();
    });
    
    jQuery(".sliderspot.spot1").click(function() {
      stopChange();
      changeDown();
      startChange();
    });
    
    //FUNCTIONS TO CONTROL TIMING CHANGES
    function startChange() {
    changeIt = setInterval(function(){ 
    changeUp();
    }, 10000);
    };
    
    function stopChange() {
        clearInterval(changeIt);
    }
});

jQuery( document ).ready(function() {
    setTimeout(
        function() 
        {
          var select = document.querySelector('.cart__widget-content select#address_country');
            select.value = 'FR';
        
            var event = document.createEvent("HTMLEvents");
            event.initEvent("change",true,false);
            select.dispatchEvent(event);
        }, 1000);
});